:host {
  --aha-toast--position: fixed;
  --aha-toast--background-color: ;
  --aha-toast--timer-bar-color: ;
  --aha-toast--color: ;
  --aha-toast--fade-out-duration: var(--reduced-motion-duration, 0.3s);
  --aha-toast--animation-duration: var(--reduced-motion-duration, 0.3s);
  --aha-toast--close-button-animation-duration: var(--reduced-motion-duration, 0.1s);

  display: inline-block;
  position: var(--aha-toast--position);
  z-index: 2147483647; /* Max possible z-index */
  opacity: 1;
  transition: opacity var(--aha-toast--fade-out-duration) ease-out;
  background-color: var(--aha-toast--background-color);
  border-radius: var(--Common--border-radius);
  border: 3px solid var(--theme-primary-background);
  color: var(--aha-toast--color);
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  transform-origin: center center;
  box-shadow: var(--theme-shadow-deep);
}
:host * {
  box-sizing: border-box;
}
:host([dismissed]) {
  opacity: 0;
}
:host([type='warning']) {
  --aha-toast--background-color: var(--theme-alert-warning-background);
  --aha-toast--timer-bar-color: var(--theme-alert-warning-border);
  --aha-toast--color: var(--theme-alert-warning-text);
}

:host([type='success']) {
  --aha-toast--background-color: var(--theme-alert-success-background);
  --aha-toast--timer-bar-color: var(--theme-alert-success-border);
  --aha-toast--color: var(--theme-alert-success-text);
}

:host([type='danger']) {
  --aha-toast--background-color: var(--theme-alert-danger-background);
  --aha-toast--timer-bar-color: var(--theme-alert-danger-border);
  --aha-toast--color: var(--theme-alert-danger-text);
}

:host([type='info']) {
  --aha-toast--background-color: var(--theme-alert-info-background);
  --aha-toast--timer-bar-color: var(--theme-alert-info-border);
  --aha-toast--color: var(--theme-alert-info-text);
}

:host([position='center']) {
  top: 50%;
  left: 50%;
  transform-origin: 0% 0%;
  transform: translate(-50%, -50%);
  animation: explode var(--aha-toast--animation-duration) ease-in-out forwards;
}
:host([position='top-left']) {
  animation: moveDown var(--aha-toast--animation-duration) ease-in-out forwards;
  left: 1rem;
}
:host([position='top']) {
  animation: moveDownCenter var(--aha-toast--animation-duration) ease-in-out forwards;
  left: 50%;
}
:host([position='top-right']) {
  animation: moveDown var(--aha-toast--animation-duration) ease-in-out forwards;
  right: 1rem;
}
:host([position='bottom-left']) {
  animation: moveUp var(--aha-toast--animation-duration) ease-in-out forwards;
  left: 1rem;
}
:host([position='bottom']) {
  animation: moveUpCenter var(--aha-toast--animation-duration) ease-in-out forwards;
  left: 50%;
}
:host([position='bottom-right']) {
  right: 1rem;
  animation: moveUp var(--aha-toast--animation-duration) ease-in-out forwards;
}

#wrapper {
  display: inline-flex;
  gap: var(--spacer-3);
  align-items: center;
  padding: var(--spacer-2) var(--spacer-4);
}
#wrapper ::slotted(*) {
  flex: 1 1;
}
#close {
  flex-shrink: 1;
}
button {
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  cursor: pointer;
  opacity: 0.5;
  transform: scale(0.8);
  transition: all var(--aha-toast--close-button-animation-duration) linear;
  &:hover,
  &:focus {
    opacity: 1;
    transform: scale(1);
    color: var(--theme-alert-danger-text);
  }
}
:host(:not([persistent])) #timer {
  width: 100%;
  height: 3px;
  background-color: var(--aha-toast--timer-bar-color);
  animation: countdown var(--aha-toast--duration) linear forwards;
}
:host([persistent]) #timer {
  display: none;
}

@keyframes countdown {
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}

@keyframes moveDown {
  0% {
    top: 0rem;
    transform: translateY(-100%);
  }
  90% {
    top: 2rem;
    transform: translateY(0%);
  }
  100% {
    top: 1rem;
  }
}
@keyframes moveDownCenter {
  0% {
    top: 0rem;
    transform: translate(-50%, -100%);
  }
  90% {
    top: 2rem;
    transform: translate(-50%, 0%);
  }
  100% {
    top: 1rem;
    transform: translate(-50%, 0%);
  }
}
@keyframes moveUp {
  0% {
    bottom: 0rem;
    transform: translateY(100%);
  }
  90% {
    bottom: 2rem;
    transform: translateY(0%);
  }
  100% {
    bottom: 1rem;
  }
}
@keyframes moveUpCenter {
  0% {
    bottom: 0rem;
    transform: translate(-50%, 100%);
  }
  90% {
    bottom: 2rem;
    transform: translate(-50%, 0%);
  }
  100% {
    bottom: 1rem;
    transform: translate(-50%, 0%);
  }
}
@keyframes explode {
  0% {
    filter: opacity(0);
    scale: 0;
  }
  90% {
    filter: opacity(1);
    scale: 1.2;
  }
  100% {
    scale: 1;
  }
}
